// extracted by mini-css-extract-plugin
export default {"main":"FormTextArea_main__6nTLV"};